import { defineMessages } from "react-intl";

export default defineMessages({
  titleFiles: {
    id: "AppointmentFile.AppointmentFileForm.titleFiles",
    defaultMessage: "Files",
  },
});
